export const isNetworkError = (e: unknown): boolean => {
  const msg =
    e instanceof Error
      ? e.message
      : e && typeof e === 'object' && 'message' in e && typeof (e as { message: unknown }).message === 'string'
        ? (e as { message: string }).message
        : null;
  if (!msg) return false;
  // Chrome/Edge: "Failed to fetch" · Firefox: "NetworkError when attempting…"
  // Safari: "Load failed" · postgrest-js wraps as "TypeError: Failed to fetch"
  return /failed to fetch|networkerror|load failed/i.test(msg);
};
